import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "state/clientLossRstr/selectors";
import { setDefinition } from "state/clientLossRstr/actions";
import Checkbox from "@ls/react-checkbox";
import styled from "styled-components";
import ClientLossRstrDefinition from "state/clientLossRstr/ClientLossRstrDefinition";
const Item = styled.div`
  padding: 5px;
  margin: 0 0 5px 0;
  background: #bfbfbf;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  border: 1px solid #a2a2a2;
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
`;
const ClientLossRstrSelector = () => {
  const definition = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  )?.[0];
  const dispatch = useDispatch();



  const [setClientLossRstr] = useMemo(() => {
    return [
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setClientLossRstr(value)
              : new ClientLossRstrDefinition({ clientLossRstr: true })
          )
        ),
    ];
  }, [definition, dispatch]);
  return (
    <>
      <Item>
        <Checkbox
          label={"Client Loss Restrictions"}
          value={definition?.clientLossRstr ?? false}
          onChange={setClientLossRstr}
        />
      </Item>

    </>
  );
};

export default ClientLossRstrSelector;
